import { useDeviceStore } from '@/store/deviceStore'

export function useDeviceContext() {
  return useDeviceStore((s) => s.deviceContext)
}
